import { useEffect } from "react";
import { CloseIcon } from "../ui/Icons";

interface IGuideModalProps {
  onClose: () => void;
}

/** Guía de usuario servida como HTML estático desde `public/`. */
const GUIDE_URL: string = "/flujo-usuario-simple.html";

export default function GuideModal({ onClose }: IGuideModalProps) {
  // cerrar con escape y bloquear el scroll del fondo mientras esta abierta
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Guía de uso"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="doc-panel">
        <div className="doc-panel__head">
          <div className="doc-panel__head-text">
            <h2 className="doc-panel__title">Guía de uso</h2>
            <p className="doc-panel__sub">Cómo funciona el sistema, paso a paso</p>
          </div>

          <a
            className="btn btn--sm btn--ghost"
            href={GUIDE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Abrir en pestaña nueva
          </a>

          <button type="button" className="modal__close" onClick={onClose}>
            <CloseIcon size={17} />
            <span className="sr-only">Cerrar</span>
          </button>
        </div>

        <iframe className="doc-frame" src={GUIDE_URL} title="Guía de uso" />
      </div>
    </div>
  );
}
